
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { OilIntakeLogModel, VendorResponse } from "../../models/oilProduction-model";
import oilProductionService from "../../services/oilProduction/oilProductionservice";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";


interface Option {
  label: string;
  value: number;
}

interface VendorOption {
  label: string;
  value: number;
  totalQuantity?: number;
}

interface InvoiceOption {
  label: string;
  value: number;
  invoiceNumber: string;
  quantity: number;
  oilIntakeInvoiceDetailId?: number;
  rawMaterialPurchaseId?: number;
}

interface EditProductionLogDialogProps {
  visible: boolean;
  selectedRow: OilIntakeLogModel | null;
  toastRef: React.RefObject<Toast>;
  onSuccess: () => void;
  onCancel: () => void;
  onDataRefresh?: () => void;
  rawMaterialPurchases?: {
    rawMaterialPurchaseID: number;
    invoiceNumber: string;
    oilSeedWeight: number;
  }[];
}

const EditProductionLogDialog: React.FC<EditProductionLogDialogProps> = ({
  visible,
  selectedRow,
  toastRef,
  onSuccess,
  onCancel,
}) => {
  const [selectedOperator1, setSelectedOperator1] = useState<number | null>(null);
  const [selectedOperator2, setSelectedOperator2] = useState<number | null>(null);
  const [selectedBull1, setSelectedBull1] = useState<number | null>(null);
  const [selectedBull2, setSelectedBull2] = useState<number | null>(null);
  const [gaanaNumber, setGaanaNumber] = useState<number | null>(null);
  const [gaanaName, setGannaName] = useState<string | null>(null);
  const [gaanaOptions, setGaanaOptions] = useState<Option[]>([]);
  const [oilseedWeight, setOilseedWeight] = useState<number | null>(null);
  const [moistureContent, setMoistureContent] = useState<number | null>(null);
  const [emptyContainerWeight, setEmptyContainerWeight] = useState<number | null>(null);
  const [vendors, setVendors] = useState<Option[]>([]);
  const [vendorInvoices, setVendorInvoices] = useState<VendorResponse[]>([]);
  const [operators, setOperators] = useState<Option[]>([]);
  const [bulls, setBulls] = useState<Option[]>([]);
  const [manufactureId, setManufactureId] = useState<number | null>(null);
  const [selectedGaanaId, setSelectedGaanaId] = useState<number | null>(null);
  const [oilseedOptions, setOilseedOptions] = useState<Option[]>([]);
  const [oilseed, setOilseed] = useState<number | null>(null);
  const [vendorOptions, setVendorOptions] = useState<VendorOption[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<number | null>(null);
  const [invoiceOptions, setInvoiceOptions] = useState<InvoiceOption[]>([]);
  const [selectedInvoices, setSelectedInvoices] = useState<number[]>([]);

  const [invoiceInputMap, setInvoiceInputMap] = useState<{
    rawMaterialPurchaseID: number;
    invoiceNumber: string;
    qty: number;
    maxQty: number;
    editable: boolean;
    oilIntakeInvoiceDetailId: number;
  }[]>([]);

  const [startTime, setStartTime] = useState<Date | null>(new Date());
  const [endTime, setEndTime] = useState<Date | null>(new Date(Date.now() + 2 * 60 * 60 * 1000));
  const [date, setDate] = useState<Date | null>(new Date());
  const [POSID, setPOSID] = useState<number | null>(null);
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [cakeWeight, setCakeWeight] = useState<number | null>(null);
  const [residueContainerWeight, setResidueContainerWeight] = useState<number | null>(null);
  const [MUOptions, setMUOptions] = useState<Option[]>([]);
  const [selectedMU, setSelectedMU] = useState<number | null>(null);
  const [residueWeight, setResidueWeight] = useState<number | null>(null);
  const [containerAndMaddiWeight, setContainerAndMaddiWeight] = useState<number | null>(null);
  const [maddiWeight, setMaddiWeight] = useState<number | null>(null);
  const [totalWeight, setTotalWeight] = useState<number | null>(null);
  const [containerMaddiWeight, setContainerMaddiWeight] = useState<number | null>(null);
  const [dailyOutputLitres, setDailyOutputLitres] = useState<number | null>(null);
  const [inputToOutputRatio, setInputToOutputRatio] = useState<number | null>(null);
  const [showResidueFields, setShowResidueFields] = useState(false);
  const MIN_OILSEED_WEIGHT = 12;
  const MAX_OILSEED_WEIGHT = 25;

  const [batchOptions, setBatchOptions] = useState<Option[]>([
    { label: "Batch 1", value: 1 },
    { label: "Batch 2", value: 2 },
    { label: "Batch 3", value: 3 },
    { label: "Batch 4", value: 4 }
  ]);
  const [selectedBatch, setSelectedBatch] = useState<number | null>(null);
  const [isFetchingBatchTiming, setIsFetchingBatchTiming] = useState(false);

  const isEditMode = !!selectedRow;

  const formatDateForAPI = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const parseTimeString = (timeStrParam: string): Date => {
    let timeStr = timeStrParam;

    if (timeStr.includes(':') && !timeStr.toUpperCase().includes('AM') && !timeStr.toUpperCase().includes('PM')) {
      const [hours, minutes, seconds] = timeStr.split(":").map(Number);
      const d = new Date();
      d.setHours(hours, minutes, seconds || 0, 0);
      return d;
    }

    timeStr = timeStr.trim().toUpperCase();
    if (timeStr.includes(':')) {
      const timeParts = timeStr.split(':');
      let hours = parseInt(timeParts[0]);
      const minutes = parseInt(timeParts[1]);

      if (timeStr.includes('AM') || timeStr.includes('PM')) {
        if (timeStr.includes('PM') && hours < 12) hours += 12;
        if (timeStr.includes('AM') && hours === 12) hours = 0;
      }

      const d = new Date();
      d.setHours(hours, minutes, 0, 0);
      return d;
    }

    const d = new Date();
    d.setHours(8, 0, 0, 0);
    return d;
  };

  const handleStartTimeChange = (selectedTime: Date | null) => {
    if (!selectedTime) return;

    setStartTime(selectedTime);
    const newEndTime = new Date(selectedTime.getTime() + 2 * 60 * 60 * 1000);
    setEndTime(newEndTime);
  };

  const handleEndTimeChange = (selectedTime: Date | null) => {
    if (!selectedTime || !startTime) return;

    if (selectedTime <= startTime) {
      toastRef.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "End time must be after start time",
        life: 3000,
      });

      const minimumEndTime = new Date(startTime.getTime() + 15 * 60 * 1000);
      setEndTime(minimumEndTime);
    } else {
      setEndTime(selectedTime);
    }
  };

  const fetchBatchTiming = async (batchId: number) => {
    if (!batchId) return;

    setIsFetchingBatchTiming(true);
    try {
      const batchTiming = await oilProductionService.getBatchTiming(batchId);

      if (batchTiming && batchTiming.startTime && batchTiming.endTime) {
        const today = new Date();

        const startTimeObj = parseTimeString(batchTiming.startTime);
        const endTimeObj = parseTimeString(batchTiming.endTime);

        const startTimeDate = new Date(today);
        startTimeDate.setHours(startTimeObj.getHours(), startTimeObj.getMinutes(), 0, 0);

        const endTimeDate = new Date(today);
        endTimeDate.setHours(endTimeObj.getHours(), endTimeObj.getMinutes(), 0, 0);

        if (endTimeDate <= startTimeDate) {
          endTimeDate.setDate(endTimeDate.getDate() + 1);
        }

        setStartTime(startTimeDate);
        setEndTime(endTimeDate);
      } else {
        console.warn("Invalid batch timing response:", batchTiming);
        const now = new Date();
        const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);
        setStartTime(now);
        setEndTime(twoHoursLater);
      }
    } catch (error) {
      console.error("Error fetching batch timing:", error);
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load batch timing",
        life: 3000,
      });
      const now = new Date();
      const twoHoursLater = new Date(now.getTime() + 2 * 60 * 60 * 1000);
      setStartTime(now);
      setEndTime(twoHoursLater);
    } finally {
      setIsFetchingBatchTiming(false);
    }
  };

  const loadOperatorsAndBullsForEdit = async (oilIntakeLogId: number) => {
    try {
      const membersResponse = await oilProductionService.getBullsAndOperatorsByOilIntakeLogId(
        oilIntakeLogId
      );

      if (membersResponse) {
        const gaanaList: Option[] = (membersResponse.gaanaDetails || []).map(
          (g: any) => ({
            label: String(g.gaanaName),
            value: g.id,
          })
        );
        setGaanaOptions(gaanaList);

        const operatorList = (membersResponse.operators || []).map((op: any) => ({
          label: op.name,
          value: op.id,
        }));
        setOperators(operatorList);

        const bullList = (membersResponse.bulls || []).map((b: any) => ({
          label: b.name,
          value: b.id,
        }));
        setBulls(bullList);
      }
    } catch (error) {
      console.error("Error loading operators and bulls:", error);
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load operators and bulls data",
        life: 3000,
      });
    }
  };

  const calculateInputToOutputRatio = (output: number | null, input: number | null) => {
    if (output != null && input != null && input > 0) {
      setInputToOutputRatio(output / input); 
    } else {
      setInputToOutputRatio(null);
    }
  };

  const calculateResidue = (cake: number | null, container: number | null) => {
    if (cake != null && container != null) {
      const result = cake - container;
      setResidueWeight(result >= 0 ? parseFloat(result.toFixed(2)) : 0);
    } else {
      setResidueWeight(null);
    }
  };

  const calculateMaddiWeight = (containerMaddi: number | null, empty: number | null) => {
    if (containerMaddi != null && empty != null) {
      const result = containerMaddi - empty;
      setMaddiWeight(result >= 0 ? parseFloat(result.toFixed(2)) : 0);
    } else {
      setMaddiWeight(null);
    }
  };

 const OIL_CONVERSION_FACTOR = 0.93; // or 0.86 – pick ONE

 const calculateDailyOutput = (
  total: number | null,
  containerMaddi: number | null
): number | null => {
  if (total == null || containerMaddi == null) return null;
  const diff = total - containerMaddi;
  return diff > 0
    ? Math.floor((diff / OIL_CONVERSION_FACTOR) * 100) / 100
    : 0;
};


  const fieldHoverStyle = (fieldName: string, isDisabled: boolean = false) => ({
    border: hoveredField === fieldName ? "2px solid #6366F1" : "1px solid #ced4da",
    boxShadow: hoveredField === fieldName ? "0 0 6px rgba(99, 102, 241, 0.3)" : "none",
    transition: "all 0.2s ease-in-out",
    width: "100%",
    minHeight: "40px",
    ...(isDisabled && { backgroundColor: "#f0f0f0", cursor: "not-allowed" })
  });

  const sanitizeNonNegative = (val: number | null | undefined): number | null => {
    if (val === null || val === undefined) return null;
    return val < 0 ? 0 : val;
  };

  const isInvalidNumber = (val: number | null | undefined) =>
    val === null || val === undefined || isNaN(val) || val <= 0;

  const validateForm = (): boolean => {
    const validations = [
      { cond: !date, msg: "Please select Date" },
      { cond: !selectedMU, msg: "Please select Manufacturing Unit" },
      { cond: !selectedGaanaId, msg: "Please select Gaana Name" },
      { cond: !selectedBatch, msg: "Please select Batch" },
      { cond: !startTime, msg: "Please select Start Time" },
      { cond: !endTime, msg: "Please select End Time" },

      { cond: !oilseed, msg: "Please select Oilseed" },
      { cond: !selectedVendor, msg: "Please select Vendor" },
      { cond: invoiceInputMap.length === 0, msg: "Please select Invoice(s)" },
      { cond: oilseedWeight === null || oilseedWeight < MIN_OILSEED_WEIGHT || oilseedWeight > MAX_OILSEED_WEIGHT, msg: `Oilseed Weight must be between ${MIN_OILSEED_WEIGHT} kg and ${MAX_OILSEED_WEIGHT} kg`, },

      { cond: isInvalidNumber(moistureContent), msg: "Please enter Moisture Content" },
      { cond: isInvalidNumber(emptyContainerWeight), msg: "Please enter Empty Container Weight" },

      { cond: !selectedOperator1, msg: "Please select Operator 1" },
      { cond: !selectedBull1, msg: "Please select Bull 1" },

      { cond: isInvalidNumber(cakeWeight), msg: "Please enter Cake Weight" },
      { cond: isInvalidNumber(residueContainerWeight), msg: "Please enter Residue Container Weight" },

      { cond: isInvalidNumber(totalWeight), msg: "Please enter Total Weight (Container + Oil)" },

      { cond: isInvalidNumber(containerAndMaddiWeight), msg: "Please enter Actual Maddi Weight with Container" },
      { cond: maddiWeight === null, msg: "Maddi Weight not calculated" },
      { cond: dailyOutputLitres === null, msg: "Daily Output not calculated" },
      { cond: inputToOutputRatio === null, msg: "Input to Output Ratio not calculated" },
      { cond: dailyOutputLitres !== null && oilseedWeight !== null && dailyOutputLitres > oilseedWeight, msg: "Total Weight (litres) cannot exceed Oilseed Weight (kg)" },
    ];

    for (const v of validations) {
      if (v.cond) {
        toastRef.current?.show({
          severity: "error",
          summary: "Validation",
          detail: v.msg,
          life: 3000,
        });
        return false;
      }
    }

    return true;
  };

  const handleEditSave = async () => {
    const isValid = validateForm();
    if (!isValid) return;

    if (!selectedRow) {
      toastRef.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "No record selected for editing",
        life: 3000,
      });
      return;
    }

    const formatDateForSubmission = (date: Date | null): string => {
      if (!date) {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const intakeLog = {
      id: selectedRow.id,
      rawMaterialPurchases: invoiceInputMap.map(inv => ({
        rawMaterialPurchaseID: inv.rawMaterialPurchaseID,
        invoiceNumber: inv.invoiceNumber,
        oilSeedWeight: inv.qty,
        oilIntakeInvoiceDetailID: inv.oilIntakeInvoiceDetailId ?? 0,
      })),

      vendorID: selectedVendor ?? 0,
      posID: selectedMU ?? 0,
      submittedDate: formatDateForSubmission(date),
      startTime: startTime?.toTimeString().split(" ")[0],
      endTime: endTime?.toTimeString().split(" ")[0],
      gaanaID: selectedGaanaId ?? 0,
      oilSeedID: oilseed ?? 0,
      oilSeedWeight: oilseedWeight ?? 0,
      moistureContent: moistureContent ?? 0,
      emptyContainerWeightKG: emptyContainerWeight ?? 0,
      operator1ID: selectedOperator1 ?? 0,
      operator2ID: selectedOperator2 ?? null,
      bull1ID: selectedBull1 ?? 0,
      bull2ID: selectedBull2 ?? null,
      batch: selectedBatch ?? null,
    };

    const processingOutput = {
      totalOilWeightWithContainerKG: totalWeight ?? 0,
      containerAndBottomMaddiWeight: containerAndMaddiWeight ?? 0,
      maddiWeightWithContainer: containerMaddiWeight ?? 0,
      maddiWeight: maddiWeight ?? 0,
      byProductID: 1,
      dailyOutputLitres: dailyOutputLitres ?? 0,
      inputToOutputRatio: inputToOutputRatio ?? null,
      capacityLossReason: "",
    };

    const cakeOutput = {
      cakeWeightKG: cakeWeight ?? 0,
      residueContainerWeightKG: residueContainerWeight ?? 0,
      residueWeightKG: residueWeight ?? 0,
      byProductID: 1,
    };

    const payload = {
      intakeLog,
      processingOutput,
      cakeOutput,
    };

    try {
      const result = await oilProductionService.editOilIntakeLog(payload);

      if (result.isSuccess) {
        toastRef.current?.show({
          severity: "success",
          summary: "Success",
          detail: result.message ?? "Oil Processing Output updated successfully",
          life: 3000,
        });
        onSuccess();
      } else {
        toastRef.current?.show({
          severity: "error",
          summary: "Error",
          detail: result.message ?? "Failed to update oil intake log",
          life: 5000,
        });
      }
    } catch (error) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to update oil intake log",
        life: 5000,
      });
    }
  };

  const initializeEditData = async () => {
    if (!selectedRow) return;

    setGaanaNumber(selectedRow.gaanaID ?? null);
    setSelectedGaanaId(selectedRow.gaanaID ?? null);
    setSelectedBatch(selectedRow.batch || null);
    setSelectedMU(selectedRow.posID ?? null);

    try {
      await loadOperatorsAndBullsForEdit(selectedRow.id);

      setSelectedOperator1(selectedRow.operator1ID || null);
      setSelectedOperator2(selectedRow.operator2ID || null);

      setSelectedBull1(selectedRow.bull1ID || null);
      setSelectedBull2(selectedRow.bull2ID || null);

      const rowDate = selectedRow.submittedDate ? new Date(selectedRow.submittedDate) : new Date();
      setDate(rowDate);

      setStartTime(selectedRow.startTime ? parseTimeString(selectedRow.startTime) : new Date());
      setEndTime(selectedRow.endTime ? parseTimeString(selectedRow.endTime) : new Date(Date.now() + 2 * 60 * 60 * 1000));

      const oilseedResponse = await oilProductionService.GetManufacturingunitWiseRawMaterials(selectedRow.posID);

      const oilseedList: Option[] = (oilseedResponse || []).map((o: any) => ({
        label: `${o.rawMaterialName || o.oilSeedName || "Unknown"} (${o.currentStock || 0} ${o.measurementTypeName || "kg"})`,
        value: o.rawMaterialId || o.oilSeedID || 0,
      }));
      setOilseedOptions(oilseedList);

      const prefilledOilseed = oilseedList.find((o) => o.value === selectedRow.oilSeedID);
      setOilseed(prefilledOilseed?.value || null);

      if (prefilledOilseed) {
        const vendorsResponse = await oilProductionService.getvendorInvoiceforOilintakeEdit({
          rawMaterialId: prefilledOilseed.value,
          posId: selectedRow.posID,
          oilIntakeLogId: selectedRow.id,
        });

        setVendorInvoices(vendorsResponse);

        const formattedVendors: VendorOption[] = vendorsResponse.map((v: any) => ({
          label: `${v.vendorName} - ${v.totalQuantity ?? 0} kg`,
          value: v.vendorId,
          totalQuantity: v.totalQuantity,
        }));
        setVendorOptions(formattedVendors);

        const vendorIdToMatch = Number(selectedRow.vendorID ?? 0);
        const prefilledVendor = formattedVendors.find((v: VendorOption) => Number(v.value) === vendorIdToMatch);
        setSelectedVendor(prefilledVendor?.value ?? null);

        const vendorObj = vendorsResponse.find((v: any) => Number(v.vendorId) === vendorIdToMatch);

        if (vendorObj?.invoices) {
          const formattedInvoices: InvoiceOption[] = vendorObj.invoices.map((inv: any) => ({
            label: `${inv.invoiceNumber} - ${inv.quantity} kg`,
            value: inv.rawMaterialPurchaseId ?? inv.rawMaterialPurchaseID,
            rawMaterialPurchaseId: inv.rawMaterialPurchaseId ?? inv.rawMaterialPurchaseID,
            invoiceNumber: inv.invoiceNumber,
            quantity: inv.quantity,
            oilIntakeInvoiceDetailId: selectedRow.rawMaterialPurchases.filter(x => x.rawMaterialPurchaseID === inv.rawMaterialPurchaseID && x.invoiceNumber === inv.invoiceNumber)?.[0]?.oilIntakeInvoiceDetailId ?? 0,
          }));

          setInvoiceOptions(formattedInvoices);


          if ((selectedRow as any).rawMaterialPurchases?.length) {

            const selectedIds: number[] = [];
            const map: typeof invoiceInputMap = [];

            (selectedRow as any).rawMaterialPurchases.forEach((p: any) => {
              const purchaseId = Number(p.rawMaterialPurchaseId ?? p.rawMaterialPurchaseID ?? 0);
              const intakeId = Number(p.oilIntakeInvoiceDetailId ?? p.oilIntakeInvoiceDetailID ?? 0);

              const invoiceMeta = formattedInvoices.find(
                inv => Number(inv.value) === purchaseId ||
                       Number(inv.oilIntakeInvoiceDetailId ?? 0) === intakeId ||
                       Number(inv.rawMaterialPurchaseId ?? 0) === purchaseId
              );

              const optionValueToSelect = invoiceMeta ? Number(invoiceMeta.value) : purchaseId;
              selectedIds.push(optionValueToSelect);
              const availableQty = invoiceMeta?.quantity ?? p.oilSeedWeight;
              map.push({
                rawMaterialPurchaseID: purchaseId,
                invoiceNumber: p.invoiceNumber,
                qty: p.oilSeedWeight,
                maxQty: availableQty ?? p.oilSeedWeight,
                editable: true,
                oilIntakeInvoiceDetailId: intakeId ?? 0,
              });
            });

            setInvoiceInputMap(map);
            setSelectedInvoices(selectedIds);
            setOilseedWeight(map.reduce((s, x) => s + x.qty, 0));
          } else {
            setSelectedInvoices([]);
            setInvoiceInputMap([]);
          }
        } else {
          setInvoiceOptions([]);
          setSelectedInvoices([]);
          setInvoiceInputMap([]);
        }
      }

      setMoistureContent(selectedRow.moistureContent ?? null);

      const emptyWeight = selectedRow.emptyContainerWeightKG ?? null;
      setEmptyContainerWeight(emptyWeight);

      // Auto-calculate containerMaddiWeight and residueContainerWeight if emptyContainerWeight exists
      // This ensures values show correctly even when reopening the dialog
      if (emptyWeight != null) {
        const calculatedContainerMaddi = Number((emptyWeight + 0.3).toFixed(2));
        const calculatedResidueContainer = Number((emptyWeight + 0.3).toFixed(2));

        // Only use calculated values if the record doesn't have existing values (created without byproduct)
        setContainerMaddiWeight(
          selectedRow.dailyOutputs?.[0]?.maddiWeightwithContainer ?? calculatedContainerMaddi
        );
        setResidueContainerWeight(
          selectedRow.cakeOutputs?.[0]?.residueContainerWeightKG ?? calculatedResidueContainer
        );
      } else {
        setContainerMaddiWeight(selectedRow.dailyOutputs?.[0]?.maddiWeightwithContainer ?? null);
        setResidueContainerWeight(selectedRow.cakeOutputs?.[0]?.residueContainerWeightKG ?? null);
      }

      setResidueWeight(selectedRow.cakeOutputs?.[0]?.residueWeightKG ?? null);
      setCakeWeight(selectedRow.cakeOutputs?.[0]?.cakeWeightKG ?? null);
      setTotalWeight(selectedRow.dailyOutputs?.[0]?.totalOilWeightWithContainerKG ?? null);
      // setDailyOutputLitres(selectedRow.dailyOutputs?.[0]?.dailyOutputLitres ?? null);
      setContainerAndMaddiWeight(selectedRow.dailyOutputs?.[0]?.containerandBottomMaddiWeight ?? null);
      setMaddiWeight(selectedRow.dailyOutputs?.[0]?.maddiWeight ?? null);
      setInputToOutputRatio(selectedRow.dailyOutputs?.[0]?.inputToOutputRatio ?? null);

    } catch (error) {
      console.error("Error initializing edit data:", error);
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load edit data",
        life: 3000,
      });
    }
  };

  const handleMUChange = async (newMU: number | null) => {
    setSelectedMU(newMU);
    if (!newMU) return;

    setSelectedGaanaId(null);
    setGaanaNumber(null);
    setSelectedBatch(null);

    const resetTime = new Date();
    resetTime.setHours(0, 0, 0, 0);
    setStartTime(resetTime);
    setEndTime(resetTime);

    setOilseed(null);
    setSelectedVendor(null);
    setSelectedInvoices([]);
    setInvoiceInputMap([]);
    setOilseedWeight(null);
    setSelectedOperator1(null);
    setSelectedOperator2(null);
    setSelectedBull1(null);
    setSelectedBull2(null);

    setMoistureContent(null);
    setEmptyContainerWeight(null);
    setCakeWeight(null);
    setTotalWeight(null);
    setContainerAndMaddiWeight(null);
    setResidueContainerWeight(null);
    setResidueWeight(null);
    setContainerMaddiWeight(null);
    setMaddiWeight(null);
    setDailyOutputLitres(null);
    setInputToOutputRatio(null);

    setVendorOptions([]);
    setInvoiceOptions([]);
    setVendorInvoices([]);

    try {
      const formattedDate = formatDateForAPI(date || new Date());
      const batchNumber = 0;
      const membersResponse = await oilProductionService.getBullsAndOperatorsByDate(
        newMU,
        formattedDate,
        batchNumber
      );

      if (membersResponse) {
        const gaanaList: Option[] = (membersResponse.gaanaDetails || []).map(
          (g: any) => ({
            label: String(g.gaanaName || ""),
            value: g.id,
          })
        );
        setGaanaOptions(gaanaList);

        const operatorList = (membersResponse.operators || []).map((op: any) => ({
          label: op.name || "",
          value: op.id,
        }));
        setOperators(operatorList);

        const bullList = (membersResponse.bulls || []).map((b: any) => ({
          label: b.name || "",
          value: b.id,
        }));
        setBulls(bullList);
      }
    } catch (err) {
      console.error(err);
    }

    try {
      const oilseedResponse = await oilProductionService.GetManufacturingunitWiseRawMaterials(newMU);
      const oilseedList: Option[] = (oilseedResponse || []).map((o: any) => ({
        label: `${o.rawMaterialName || o.oilSeedName || "Unknown"} (${o.currentStock || 0} ${o.measurementTypeName || "kg"})`,
        value: o.rawMaterialId || o.oilSeedID || 0,
      }));
      setOilseedOptions(oilseedList);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const fetchMUOptions = async () => {
      try {
        const response = await oilProductionService.GetMUPlantName();
        if (response && response.length > 0) {
          const formattedOptions = response.map((p: any) => ({
            label: p.address2,
            value: p.posID,
          }));
          setMUOptions(formattedOptions);
        }
      } catch (error) {
        console.error("Error fetching MU options:", error);
      }
    };

    fetchMUOptions();
  }, []);

  useEffect(() => {
    if (visible && selectedRow) {
      initializeEditData();
    }
  }, [visible, selectedRow]);

  // 🔄 Keep selected invoice IDs valid if invoiceOptions refresh
  useEffect(() => {
    if (!invoiceOptions.length || !selectedInvoices.length) return;
    const validIds = selectedInvoices.filter(id =>
      invoiceOptions.some(opt => opt.value === id)
    );
    if (validIds.length !== selectedInvoices.length) {
      setSelectedInvoices(validIds);
    }
  }, [invoiceOptions]);

  useEffect(() => {
    // Only reset if vendor is explicitly cleared (not on initial load)
    if (selectedVendor === null && selectedInvoices.length > 0) {
      setSelectedInvoices([]);
      setInvoiceInputMap([]);
      setOilseedWeight(null);
    }
  }, [selectedVendor]);

  // useEffect(() => {
  //   if (totalWeight != null && containerMaddiWeight != null) {
  //     const diff = totalWeight - containerMaddiWeight;
  //     const output = diff > 0 ? Number((diff / 0.9).toFixed(2)) : 0;
  //     setDailyOutputLitres(output);
  //   } else {
  //     setDailyOutputLitres(null);
  //   }
  // }, [totalWeight, containerMaddiWeight]);

  useEffect(() => {
  const output = calculateDailyOutput(totalWeight, containerMaddiWeight);
  setDailyOutputLitres(output);
}, [totalWeight, containerMaddiWeight]);


 useEffect(() => {
  calculateInputToOutputRatio(dailyOutputLitres, oilseedWeight);
}, [dailyOutputLitres, oilseedWeight]);


  useEffect(() => {
    if (
      containerAndMaddiWeight != null &&
      emptyContainerWeight != null
    ) {
      const result = containerAndMaddiWeight - emptyContainerWeight;
      setMaddiWeight(result >= 0 ? Number(result.toFixed(2)) : 0);
    } else {
      setMaddiWeight(null);
    }
  }, [containerAndMaddiWeight, emptyContainerWeight]);

  useEffect(() => {
  if (emptyContainerWeight != null) {
    const calculated = emptyContainerWeight + 0.3;
    setContainerMaddiWeight(Number(calculated.toFixed(2)));
  } else {
    setContainerMaddiWeight(null);
  }
}, [emptyContainerWeight]);

useEffect(() => {
  if (emptyContainerWeight != null) {
    const calculated = emptyContainerWeight + 0.3;
    setResidueContainerWeight(Number(calculated.toFixed(2)));
  } else {
    setResidueContainerWeight(null);
  }
}, [emptyContainerWeight]);



  return (
    <Dialog
      visible={visible}
      modal
      style={{ width: "90vw" }}
      onHide={onCancel}
      footer={
        <>
          <Button
            label="Cancel"
            className="p-button-text"
            onClick={onCancel}
          />
          <Button
            label="Save"
            className="p-button-primary"
            onClick={handleEditSave}
          />
        </>
      }
    >
      <h5 className="border-round mb-3 order-top-color p-2 panel-header-text text-center">
        Edit Oil Production Log
      </h5>

      <div className="grid">
        <div className="col-12 mb-2">
          <div className="grid">
            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Date<span className="required">*</span>
              </label>
              <Calendar
                value={date}
                onChange={(e) => setDate(e.value as Date)}
                className="w-full"
                style={fieldHoverStyle("description")}
                dateFormat="dd-mm-yy"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Manufacturing Unit<span className="required">*</span>
              </label>
              <Dropdown
                value={selectedMU}
                options={MUOptions}
                onChange={(e) => handleMUChange(e.value)}
                placeholder="Select Manufacturing Unit"
                className="w-full"
                style={fieldHoverStyle("description")}
                optionLabel="label"
                optionValue="value"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Gaana Name <span className="required">*</span>
              </label>
              <Dropdown
                value={selectedGaanaId}
                options={gaanaOptions}
                onChange={(e) => setSelectedGaanaId(e.value)}
                optionLabel="label"
                optionValue="value"
                style={fieldHoverStyle("description")}
                placeholder="Select Gaana Name "
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Batch<span className="required">*</span>
              </label>
              <div className="relative">
                <Dropdown
                  value={selectedBatch}
                  options={batchOptions}
                  onChange={async (e) => {
                    const batchId = e.value;
                    setSelectedBatch(batchId);

                    if (batchId) {
                      await fetchBatchTiming(batchId);
                    }
                  }}
                  placeholder={isFetchingBatchTiming ? "Loading timing..." : "Select Batch"}
                  style={fieldHoverStyle("description")}
                  optionLabel="label"
                  disabled={isFetchingBatchTiming}
                />
                {isFetchingBatchTiming && (
                  <i className="pi pi-spin pi-spinner absolute right-3 top-3 text-gray-500" />
                )}
              </div>
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Start Time<span className="required">*</span>
              </label>
              <Calendar
                readOnlyInput
                value={startTime}
                onChange={(e) => handleStartTimeChange(e.value as Date)}
                timeOnly
                hourFormat="12"
                stepMinute={15}
                className="w-full"
                style={fieldHoverStyle("description")}
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                End Time<span className="required">*</span>
              </label>
              <Calendar
                readOnlyInput
                value={endTime}
                onChange={(e) => handleEndTimeChange(e.value as Date)}
                timeOnly
                hourFormat="12"
                stepMinute={15}
                className="w-full"
                style={fieldHoverStyle("description")}
              />
            </div>
          </div>
        </div>

        <div className="col-12 mt-1">
          <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
          <div className="grid">
            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Oilseed Name<span className="required">*</span>
              </label>
              <Dropdown
                value={oilseed}
                options={oilseedOptions}
                onChange={async (e) => {
                  const selectedOilseedObj = e.value;
                  setOilseed(selectedOilseedObj);

                  setMoistureContent(null);
                  setEmptyContainerWeight(null);
                  setCakeWeight(null);
                  setTotalWeight(null);
                  setContainerAndMaddiWeight(null);
                  setResidueContainerWeight(null);
                  setResidueWeight(null);
                  setContainerMaddiWeight(null);
                  setMaddiWeight(null);
                  setDailyOutputLitres(null);
                  setInputToOutputRatio(null);
                  setSelectedOperator1(null);
                  setSelectedOperator2(null);
                  setSelectedBull1(null);
                  setSelectedBull2(null);

                  if (!selectedOilseedObj) {
                    setVendorOptions([]);
                    setSelectedVendor(null);
                    setInvoiceOptions([]);
                    setSelectedInvoices([]);
                    setInvoiceInputMap([]);
                    return;
                  }

                  try {
                    const response = await oilProductionService.getvendorInvoiceforOilintakeEdit({
                      rawMaterialId: selectedOilseedObj,
                      posId: selectedRow?.posID,
                      oilIntakeLogId: selectedRow?.id
                    });

                    setVendorInvoices(response);

                    const formattedVendors = response.map((v: any) => ({
                      label: v.vendorName,
                      value: v.vendorId,
                      totalQuantity: v.totalQuantity ?? 0,
                    }));
                    setVendorOptions(formattedVendors);
                    setSelectedVendor(null);

                    setInvoiceOptions([]);
                    setSelectedInvoices([]);
                    setInvoiceInputMap([]);
                    setOilseedWeight(null);
                  } catch (err) {
                    console.error("Error fetching vendors:", err);
                  }
                }}
                placeholder="Select Oilseed"
                optionLabel="label"
                optionValue="value"
                className="w-full"
                style={fieldHoverStyle("description")}
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Vendor Name<span className="required">*</span>
              </label>
              <Dropdown
                value={selectedVendor}
                options={vendorOptions}
                onChange={(e) => {
                  const selectedVendorId = e.value;
                  
                  // Clear all invoice-related state first
                  setSelectedInvoices([]);
                  setInvoiceInputMap([]);
                  setOilseedWeight(null);
                  setInvoiceOptions([]);

                  // Then set new vendor
                  setSelectedVendor(selectedVendorId);

                  if (!selectedVendorId) {
                    return;
                  }

                  const vendorObj = vendorInvoices.find(
                    (v: any) => v.vendorId === selectedVendorId
                  );

                  if (vendorObj?.invoices && vendorObj.invoices.length > 0) {
                    const formattedInvoices = vendorObj.invoices.map((inv: any) => ({
                      label: `${inv.invoiceNumber} - ${inv.quantity} kg`,
                      value: inv.rawMaterialPurchaseId ?? inv.rawMaterialPurchaseID,
                      rawMaterialPurchaseId: inv.rawMaterialPurchaseId ?? inv.rawMaterialPurchaseID,
                      invoiceNumber: inv.invoiceNumber,
                      quantity: inv.quantity,
                      oilIntakeInvoiceDetailId: inv.oilIntakeInvoiceDetailId ?? inv.oilIntakeInvoiceDetailID ?? 0,
                    }));

                    setInvoiceOptions(formattedInvoices);
                  }
                }}
                  itemTemplate={(v: VendorOption) => (
    <div className="flex justify-between">
      <span>{v.label.split(" - ")[0]}</span>
      <span className="font-semibold">-{v.totalQuantity} kg</span>
    </div>
  )}
                placeholder="Select Vendor"
                className="w-full"
                style={fieldHoverStyle("description")}
                optionLabel="label"
                optionValue="value"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Invoice Number <span className="required">*</span>
              </label>
              <MultiSelect
                value={selectedInvoices}
                options={invoiceOptions}
                optionLabel="label"
                optionValue="value"
                display="chip"
                className="w-full"
                onChange={(e) => {
                  const selectedIds = e.value as number[];

                  if (selectedIds.length === 0) {
                    setSelectedInvoices([]);
                    setInvoiceInputMap([]);
                    setOilseedWeight(null);
                    return;
                  }

                  setInvoiceInputMap((prev) => {
                    const updated = selectedIds.map((id) => {
                      const existing = prev.find(p => p.rawMaterialPurchaseID === id);
                      const inv = invoiceOptions.find(i => i.value === id);
            
                      if (existing) {
                        return existing;
                      }
                      
                      return {
                        rawMaterialPurchaseID: inv!.value,
                        invoiceNumber: inv!.invoiceNumber,
                        qty: inv!.quantity,
                        maxQty: inv!.quantity,
                        editable: true,
                        oilIntakeInvoiceDetailId: inv!.oilIntakeInvoiceDetailId ?? 0,
                      };
                    });

                    const total = Number(
                      updated.reduce((sum, x) => sum + x.qty, 0).toFixed(2)
                    );

                    setOilseedWeight(total);
                    return updated;
                  });

                  setSelectedInvoices(selectedIds);
                }}
              />


              {invoiceInputMap.length > 0 && (
                <div className="mt-3">
                  <label className="label-semi-bold">
                    Selected Invoice Quantity
                  </label>

                  <div className="flex flex-column gap-2 mt-2">
                    {invoiceInputMap.map((inv, index) => (
                      <div
                        key={inv.rawMaterialPurchaseID}
                        className="flex align-items-center gap-2"
                        style={{ width: "320px" }}
                      >

                        <span
                          className="p-inputgroup-addon"
                          style={{
                            minWidth: "90px",
                            justifyContent: "center",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {inv.invoiceNumber}
                        </span>

                       <InputNumber
                          value={inv.qty}
                          min={0}
                          max={inv.maxQty}
                          mode="decimal"
                          minFractionDigits={2}
                          step={0.01}
                          inputStyle={{ textAlign: "right", width: "100%" }}

                          onChange={(e) => {
                                let value = e.value ?? 0;

                                // ❌ Block negative values
                                if (value < 0) {
                                  value = 0;
                                  toastRef.current?.show({
                                    severity: "warn",
                                    summary: "Invalid Quantity",
                                    detail: "Quantity cannot be negative",
                                    life: 2000,
                                  });
                                }

                                // ❌ Block more than invoice max
                                if (value > inv.maxQty) {
                                  value = inv.maxQty;
                                  toastRef.current?.show({
                                    severity: "warn",
                                    summary: "Invalid Quantity",
                                    detail: `Maximum allowed for this invoice is ${inv.maxQty}`,
                                    life: 2000,
                                  });
                                }

                                setInvoiceInputMap((prev) => {
                                  // Update only the edited invoice
                                  const updated = prev.map((p) =>
                                    p.rawMaterialPurchaseID === inv.rawMaterialPurchaseID
                                      ? { ...p, qty: value }
                                      : p
                                  );

                                  // 🔢 Calculate TOTAL oilseed weight
                                  const total = Number(
                                    updated.reduce((sum, x) => sum + x.qty, 0).toFixed(2)
                                  );

                                  setOilseedWeight(total);

                                  // ❌ Total must be > 0
                                  if (total === 0) {
                                    
                                    toastRef.current?.show({
                                      severity: "warn",
                                      summary: "Invalid Total Quantity",
                                      detail: `Invoice quantity must be greater than zero`,
                                      life: 2000,
                                    });
                                  }
                                  // ❌ Below minimum
                                  else if (total < MIN_OILSEED_WEIGHT) {
                                    
                                    toastRef.current?.show({
                                      severity: "warn",
                                      summary: "Invalid Total Quantity",
                                      detail: `Total oilseed weight must be at least ${MIN_OILSEED_WEIGHT} kg`,
                                      life: 2000,
                                    });
                                  }
                                  // ❌ Above maximum
                                  else if (total > MAX_OILSEED_WEIGHT) {
                                    

                                    toastRef.current?.show({
                                      severity: "warn",
                                      summary: "Invalid Total Quantity",
                                      detail: `Total oilseed weight cannot exceed ${MAX_OILSEED_WEIGHT} kg`,
                                      life: 2000,
                                    });
                                  }
                                  // ✅ Valid total
                                  else {
                                    
                                  }

                                  return updated;
                                });
                              }}

                              onKeyDown={(e) => {
                                // ❌ Block scientific notation & signs
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                        />

                        <InputText
                          value="kg"
                          disabled
                          className="text-center"
                          style={{
                            width: "60px",
                            backgroundColor: "#eef1f5",
                            fontWeight: 600,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Oilseed Weight (kg)<span className="required">*</span>
              </label>
              <InputNumber
                value={oilseedWeight}
                disabled
                mode="decimal"
                minFractionDigits={2}
                className="w-full"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Moisture Content (%)<span className="required">*</span>
              </label>
              <InputNumber
                value={moistureContent}
                min={0}
                onValueChange={(e) => setMoistureContent(sanitizeNonNegative(e.value))}
                mode="decimal"
                step={0.01}
                minFractionDigits={2}
                style={fieldHoverStyle("description")}
                 onKeyDown={(e) => {
                if (["-", "e", "E", "+"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Empty Container Weight (kg)<span className="required">*</span>
              </label>
              <InputNumber
                value={emptyContainerWeight}
                min={0}
                onChange={(e) => setEmptyContainerWeight(e.value ?? null)}
                onKeyDown={(e) => {
                  if (["-", "e", "E", "+"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                mode="decimal"
                step={0.01}
                minFractionDigits={2}
                style={fieldHoverStyle("description")}
              />
            </div>
          </div>
        </div>

        <div className="col-12 mt-2">
          <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
          <div className="grid">
            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Cake Weight <span className="required">*</span>
              </label>
              <InputNumber
                value={cakeWeight}
                min={0}
                onChange={(e) => {
                    const val = sanitizeNonNegative(e.value);
                    setCakeWeight(val);
                    calculateResidue(val, residueContainerWeight);
                }}
                placeholder="Enter Cake Weight"
                mode="decimal"
                minFractionDigits={2}
                step={0.01}
                useGrouping={false}
                style={fieldHoverStyle("cakeWeight")}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </div>

            <div className="field col-12 md:col-3" style={{ paddingRight: "0" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "0" }}>
                <button
                  type="button"
                  onClick={() => setShowResidueFields(!showResidueFields)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "1.3rem",
                    color: showResidueFields ? "#43447cff" : "#999",
                    padding: "0.5rem 0.3rem 0 0",
                    marginRight: "0",
                    flexShrink: 0
                  }}
                  title={showResidueFields ? "Hide residue fields" : "Show residue fields"}
                >
                  <i className={`pi ${showResidueFields ? "pi-eye" : "pi-eye-slash"}`} />
                </button>

                {showResidueFields && (
                  <div style={{ flex: 1, paddingLeft: "0.3rem" }}>
                    <label className="label-semi-bold" style={{ display: "block", marginBottom: "0.5rem" }}>
                      Residue Container Weight <span className="required">*</span>
                    </label>
                   <InputNumber
                      value={residueContainerWeight}
                      disabled
                      placeholder="Auto-calculated"
                      mode="decimal"
                      minFractionDigits={2}
                      className="w-full"
                      style={fieldHoverStyle("residueContainerWeight", true)}
                    />

                  </div>
                )}
              </div>
            </div>

            {showResidueFields && (
              <div className="field col-12 md:col-3">
                <label className="label-semi-bold">
                  Residue Weight <span className="required">*</span>
                </label>
                <InputNumber
                  value={residueWeight}
                  disabled
                  placeholder="Residue Weight"
                  mode="decimal"
                  minFractionDigits={2}
                  useGrouping={false}
                  className="w-full"
                  style={fieldHoverStyle("residueWeight", true)}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-12 mt-2">
          <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
          <div className="grid">
            <div className="field col-12 md:col-4">
              <label className="label-semi-bold" style={{ whiteSpace: "normal", display: "block", lineHeight: "2" }}>
                Total Weight (Container + Oil) (Kg)<span className="required">*</span>
              </label>
              <InputNumber
                value={totalWeight}
                onChange={(e) => setTotalWeight(e.value ?? null)}
                placeholder="Enter Total Weight (Container + Oil)"
                mode="decimal"
                minFractionDigits={2}
                step={0.01}
                useGrouping={false}
                className="w-full"
                style={fieldHoverStyle("totalWeight")}
                maxLength={8}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </div>

            <div className="field col-12 md:col-4">
              <label className="label-semi-bold" style={{ whiteSpace: "normal", display: "block", lineHeight: "1" }}>
                Standard Container and Bottom Maddi Weight (Kg)<span className="required">*</span>
              </label>
              <InputNumber
                value={containerMaddiWeight}
                 disabled
                placeholder="Auto-calculated"
                mode="decimal"
                minFractionDigits={2}
                useGrouping={false}
                className="w-full"
                style={fieldHoverStyle("containerMaddiWeight", true)}
                maxLength={8}
              />
            </div>

            <div className="field col-12 md:col-4">
              <label className="label-semi-bold" style={{ whiteSpace: "normal", display: "block", lineHeight: "2" }}>
                Daily Output in litres<span className="required">*</span>
              </label>
              <InputNumber
                value={dailyOutputLitres}
                disabled
                placeholder="Daily Output in litres"
                mode="decimal"
                minFractionDigits={2}
                step={0.01}
                useGrouping={false}
                className="w-full"
                style={fieldHoverStyle("dailyOutputLitres")}
                maxLength={8}
              />
            </div>
          </div>
        </div>

        <div className="col-12 mt-2">
          <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
          <div className="grid">
            <div className="field col-12 md:col-4">
              <label className="label-semi-bold">
                Actual Maddi Weight with Container<span className="required">*</span>
              </label>
              <InputNumber
                value={containerAndMaddiWeight}
                onChange={(e) => setContainerAndMaddiWeight(e.value ?? null)}
                placeholder="Enter Maddi Weight with Container"
                mode="decimal"
                minFractionDigits={2}
                step={0.01}
                useGrouping={false}
                className="w-full"
                style={fieldHoverStyle("description")}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                maxLength={8}
              />
            </div>

            <div className="field col-12 md:col-4">
              <label className="label-semi-bold">
                Maddi Weight<span className="required">*</span>
              </label>
              <InputNumber
                value={maddiWeight}
                disabled
                placeholder="Maddi Weight"
                mode="decimal"
                minFractionDigits={2}
                step={0.01}
                useGrouping={false}
                className="w-full"
                style={fieldHoverStyle("maddiWeight")}
                maxLength={8}
              />
            </div>

            <div className="field col-12 md:col-4">
              <label className="label-semi-bold">
                Input to Output Ratio<span className="required">*</span>
              </label>
              <InputNumber
                value={inputToOutputRatio !== null ? inputToOutputRatio * 100 : undefined}
                disabled
                placeholder="Input to Output Ratio"
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
                step={0.01}
                useGrouping={false}
                className="w-full"
                style={fieldHoverStyle("inputToOutputRatio")}
                maxLength={8}
                suffix="%"
              />
            </div>
          </div>
        </div>

        <div className="col-12 mt-2">
          <h5 className="mb-3 border-bottom-1 surface-border pb-1"></h5>
          <div className="grid">
            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Operator 1<span className="required">*</span>
              </label>
              <Dropdown
                value={selectedOperator1}
                options={operators.filter((op) => selectedOperator2 == null || op.value !== selectedOperator2)}
                onChange={(e) => setSelectedOperator1(e.value)}
                placeholder="Select Operator 1"
                style={fieldHoverStyle("description")}
                optionLabel="label"
                optionValue="value"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">Operator 2</label>
              <Dropdown
                value={selectedOperator2}
                options={operators.filter((op) => selectedOperator1 == null || op.value !== selectedOperator1)}
                onChange={(e) => setSelectedOperator2(e.value)}
                placeholder="Select Operator 2"
                style={fieldHoverStyle("description")}
                optionLabel="label"
                optionValue="value"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">
                Bull 1<span className="required">*</span>
              </label>
              <Dropdown
                value={selectedBull1}
                options={bulls.filter((b) => selectedBull2 == null || b.value !== selectedBull2)}
                onChange={(e) => setSelectedBull1(e.value)}
                placeholder="Select Bull 1"
                style={fieldHoverStyle("description")}
                optionLabel="label"
                optionValue="value"
              />
            </div>

            <div className="field col-12 md:col-3">
              <label className="label-semi-bold">Bull 2</label>
              <Dropdown
                value={selectedBull2}
                options={bulls.filter((b) => selectedBull1 == null || b.value !== selectedBull1)}
                onChange={(e) => setSelectedBull2(e.value)}
                placeholder="Select Bull 2"
                style={fieldHoverStyle("description")}
                optionLabel="label"
                optionValue="value"
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default EditProductionLogDialog;
